<template>
    <b-table
        :fields="fields"
        :items="products"
        responsive
    >
        <!-- A virtual column -->
        <template #cell(supplierIdentifier)="data">
            <LegalIdentity
                :view="true"
                :vertical="true"
                :identity="data.item.supplier.legalIdentity"
            />
        </template>

        <template #cell(contactName)="data">
            {{ getContactName(data.item.supplier) }}
        </template>

        <template #cell(contactEmail)="data">
            {{ getContactEmail(data.item.supplier) }}
        </template>

        <template #cell(ongoingRequest)="data">
            <div class="text-center">
                <strong v-if="data.item.ongoingRequestDate">{{ data.item.ongoingRequestDate }}</strong>
                <StatusBadge v-else-if="data.item.hasBeenApproved" type="sent" :status="statusApproved"/>
                <span v-else>-</span>
            </div>
        </template>

        <template #cell(email)="data">
            <div class="text-center">
                <span v-if="data.item.ongoingRequestDate">
                    <span v-if="data.item.isEmailSent">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="info"
                            class="mt-0"
                            size="sm"
                            :disabled="disabledButtons.includes(data.item.id)"
                            @click="sendEmail(data.item, 'button' + data.item.id)"
                        >
                            {{ $t('Page(SendRequest):Component(Button):resend-email') }}
                        </b-button>
                    </span>
                    <b-button
                        v-else
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        class="mt-0"
                        size="sm"
                        :disabled="disabledButtons.includes(data.item.id)"
                        @click="sendEmail(data.item, 'button' + data.item.id)"
                    >
                        {{ $t('Page(SendRequest):Component(Button):send-email') }}
                    </b-button>
                    <div v-if="data.item.supplierNotificationSentAt" class="text-small">
                        <small>{{ renderDateTime(data.item.supplierNotificationSentAt) }}</small>
                    </div>
                </span>
                <span v-else>-</span>
            </div>

        </template>


        <template #head(checkbox)="data">
            <b-form-checkbox
                :value="true"
                v-model="checkboxControl"
                @input="toggleAll()"
            />
        </template>

        <template #cell(checkbox)="data">
            <b-form-checkbox
                v-if="canBeSelected(data.item)"
                :value="true"
                v-model="data.item.selected"
                @input="onCheckboxChange(data.item)"
            />
        </template>

        <!-- A virtual composite column -->
        <template #cell(supplier)="data">
            {{ data.item.supplier ? data.item.supplier.title : '' }}
        </template>
    </b-table>
</template>

<script>
import { BTable, BFormCheckbox, BButton, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StatusBadge from "@/views/request/components/StatusBadge";
import {RequestStatus} from "@/libs/product";
import LegalIdentity from "@core/components/common/LegalIdentity.vue";
import dateRenderer from "@core/mixins/date-renderer";

export default {
    mixins: [dateRenderer],
    components: {
        LegalIdentity,
        BTable, StatusBadge,
        BFormCheckbox,
        BButton,
        BBadge,
    },
    directives: {
        Ripple
    },
    props: {
        products: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            statusApproved: RequestStatus.APPROVED,
            fields: [
                { key: 'checkbox', label: this.$t('Page(SendRequest):Component(Text):field-checkbox') },
                { key: 'title', label: this.$t('Page(SendRequest):Component(Text):field-name') },
                { key: 'identifier', label: this.$t('Page(SendRequest):Component(Text):field-id') },
                { key: 'supplier', label: this.$t('Page(SendRequest):Component(Text):field-supplier') },
                { key: 'supplierIdentifier', label: this.$t('Page(SendRequest):Component(Text):field-supplier-id') },
                { key: 'contactName', label: this.$t('Page(SendRequest):Component(Text):field-contact-name') },
                { key: 'contactEmail', label: this.$t('Page(SendRequest):Component(Text):field-contact-email') },
                { key: 'ongoingRequest', label: this.$t('Page(SendRequest):Component(Text):field-ongoing-request') },
                { key: 'email', label: this.$t('Page(SendRequest):Component(Text):field-email') },
            ],
            disabledButtons: [],
            checkboxControl: true
        };
    },
    methods: {
        toggleAll() {
            this.products
                .filter(this.canBeSelected)
                .forEach(p => {
                    p.selected = this.checkboxControl;
                    this.onCheckboxChange(p);
                });
        },
        getContactName(supplier) {
            return supplier.contact.name;
        },
        getContactEmail(supplier) {
            return supplier.contact.communicationChannels[0].details;
        },
        onCheckboxChange(item) {
            this.$emit('change', item);
        },
        canBeSelected(item) {
            return !item.ongoingRequestDate;
        },
        sendEmail(item) {
            this.disabledButtons.push(item.id);
            this.$emit('sendEmail', item, () => {
                let index = this.disabledButtons.findIndex(id => id === item.id);

                if (index >= 0) {
                    this.disabledButtons.splice(index, 1);
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
